import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  root: theme => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xs};
    padding: ${theme.spacing.xs} 0;
  `,

  header: theme => css`
    display: flex;
    gap: ${theme.spacing.xxs};
    align-items: center;
  `,

  cardWrapper: theme => css`
    display: flex;
    gap: ${theme.spacing.xs};
  `,

  cardContainer: css`
    display: flex;
    flex-direction: column;
  `,
})

export default useStyles
